<template>
    <div class="pay">
        <el-dialog :title="statusType == 2 ? '支付预定金' : '支付尾款'" :visible.sync="dialogVisible" width="650px" :before-close="handleClose">
            <div class="content" v-loading="load">
                <div class="word">
                    <p>本次活动费总计 {{ infoData.total_amount | numFmt }} 元</p>
                    <p>
                        <span style="margin-right: 40px">预定金 {{ infoData.deposit_amount | numFmt }} 元</span>
                        <span>尾款 {{ infoData.retain_amount | numFmt }} 元</span>
                    </p>
                    <p class="on">
                        本次支付
                        <span>{{ statusType == 2 ? infoData.deposit_amount : infoData.retain_amount | numFmt }}</span>
                        元
                    </p>
                </div>
                <div class="form">
                    <el-form label-width="140px" label-position="right">
                        <el-form-item label="请选择支付方式：">
                            <el-radio-group v-model="type">
                                <el-radio :label="1">线上支付</el-radio>
                                <el-radio :label="2">线下支付</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="支付凭证：" v-show="type == 2">
                            <div v-if="!isUpload">
                                <el-upload
                                    action="#"
                                    list-type="picture-card"
                                    :on-preview="handlePictureCardPreview"
                                    :auto-upload="false"
                                    :file-list="file"
                                    :class="file.length == 1 ? 'mf' : ''"
                                    :on-change="
                                        (file, fileList) => {
                                            handleChange(file, fileList);
                                        }
                                    "
                                    :on-remove="
                                        (file, fileList) => {
                                            handleRemove(file, fileList);
                                        }
                                    "
                                >
                                    <i slot="default" class="el-icon-plus"></i>
                                </el-upload>
                            </div>
                            <div v-else>
                                <el-image
                                    style="width: 148px; height: 148px; border-radius: 8px"
                                    :src="statusType == 2 ? payImg : endpayImg"
                                    :preview-src-list="[statusType == 2 ? payImg : endpayImg]"
                                >
                                </el-image>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-radio-group v-model="code" v-if="type == 1" @change="payChange">
                                <el-radio :label="1" border>支付宝支付</el-radio>
                                <el-radio :label="2" border>微信支付</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="订单编号：">
                            <p>{{ infoData.order_sn }}</p>
                        </el-form-item>
                        <el-form-item label="订单时间：">
                            <p>{{ infoData.create_time }}</p>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!isUpload" type="primary" @click="submit" :loading="btnload">确 定</el-button>
                <el-button v-else type="" @click="handleClose" plain>关 闭</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="imgDialog" class="imgDia" width="240px">
            <div v-loading="urlLoad" element-loading-text="加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <vue-qr :text="qrUrl" qid="testid" :margin="0"></vue-qr>
            </div>
            <p style="margin-top: 20px; text-align: center">
                {{ code == 1 ? "支付宝扫一扫" : "微信扫一扫" }}
            </p>
        </el-dialog>
        <el-dialog :visible.sync="calDialog" class="calImg">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import VueQr from "vue-qr";

export default {
    data() {
        return {
            qrUrl: "",
            imgDialog: false,
            btnload: false,
            load: false,
            dialogVisible: false,
            calDialog: false,
            type: 1,
            code: "",
            file: [],
            file_url: "",
            infoData: {
                total_amount: 0,
                deposit_amount: 0,
                retain_amount: 0,
                order_sn: 0,
                create_time: "0000-00-00",
            },
            statusType: "",
            formData: null,
            urlLoad: false,
            dialogImageUrl: "",
            payImg: "",
            endpayImg: "",
            isUpload: false,
            timer: null,
        };
    },
    components: { VueQr },
    filters: {
        numFmt(val) {
            return Number(val).toFixed(2);
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            getPayInfo: "commodity/getPayInfo",
            uploadFile: "commodity/uploadFile",
            payActivity: "commodity/payActivity",
            paymentDetail: "commodity/paymentDetail",
        }),
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.calDialog = true;
        },
        payChange() {
            this.imgDialog = true;
            this.urlLoad = true;
            this.postOrder();
        },

        submit() {
            this.btnload = true;
            if (this.type == 1) {
                this.handleClose();
            } else {
                this.uploadFile(this.formData)
                    .then((res) => {
                        if (res.code == 1) {
                            this.$message.success("上传成功！");
                            this.file_url = res.data.formdata_details[0].urls;
                        } else {
                            this.$message({
                                type: "warning",
                                message: res.msg,
                            });
                        }
                    })
                    .then(() => {
                        this.postOrder();
                    });
            }
        },
        checkPay(id) {
            let opt = {
                id: id,
                token: this.getToken,
            };
            this.paymentDetail(opt).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    if (res.data.status == 2) {
                        clearTimeout(this.timer);
                        this.$message.success("支付成功！");
                        this.imgDialog = false;
                        this.dialogVisible = false;
                        this.$emit("init");
                    } else if (res.data.status == 3) {
                        clearTimeout(this.timer);
                        this.imgDialog = false;
                        this.$message.error("支付失败！");
                    }
                }
            });
        },
        postOrder() {
            let opt = {
                token: this.getToken,
                order_sn: this.infoData.order_sn, //订单编号
                type: this.type, //支付类型 1-线上 2-线下
                image: this.file_url, //线下支付凭证图片地址
            };
            if (this.type == 1) {
                opt.code = this.code == 1 ? "AliPay" : "WeChat";
            } else {
                this.code == "";
            }
            this.payActivity(opt).then((res) => {
                clearInterval(this.timer);
                this.btnload = false;
                if (res.code == 1) {
                    if (this.type == 2) {
                        this.dialogVisible = false;
                        this.$message.success("提交成功！");
                        this.$emit("init");
                        this.handleClose();
                    } else {
                        if (!res.data.pay_url) {
                            this.$message.warning("已提交过申请，请等待审核！");
                            this.imgDialog = false;
                        } else {
                            this.qrUrl = res.data.pay_url;
                            this.urlLoad = false;
                            let i = 0;
                            this.timer = setInterval(() => {
                                setTimeout(() => {
                                    this.checkPay(res.data.id);
                                    i++;
                                    if (i >= 30) {
                                        clearInterval(this.timer);
                                    }
                                }, 0);
                            }, 10000);
                        }
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        async getInfo(id, order_id) {
            try {
                this.load = true;
                this.file = [];
                let opt = {
                    token: this.getToken,
                    activity_merchant_id: id, //需求id
                    order_activity_id: order_id, //需求订单id
                };
                let res = await this.getPayInfo(opt);
                if (res.code == 1) {
                    this.infoData = res.data;
                    if (res.data.payment.length > 0) {
                        this.isUpload = true;
                        this.type = 2;
                    }
                    if (this.statusType == 2) {
                        this.payImg = !!res.data.payment[0] ? res.data.payment[0].image : "";
                    } else {
                        this.endpayImg = !!res.data.payment[1] ? res.data.payment[1].image : "";
                    }
                } else {
                    this.$message.error(res.msg);
                }
            } catch (err) {
                console.log(err);
            } finally {
                this.load = false;
            }
        },
        handleClose() {
            clearInterval(this.timer);
            this.isUpload = false;
            this.code = "";
            this.type = 1;
            this.file = [];
            this.file_url = "";
            this.infoData = {
                total_amount: 0,
                deposit_amount: 0,
                retain_amount: 0,
                order_sn: 0,
                create_time: "0000-00-00",
            };
            this.statusType = "";
            clearTimeout(this.timer);
            this.dialogVisible = false;
        },
        // handleChange(file, fileList) {
        //     this.file.push(file);
        // },
        handleChange(file, fileList) {
            // console.log(file, fileList);
            var formdata = new FormData();
            formdata.append("formdata", file.raw);
            this.file = fileList;
            this.formData = formdata;
        },
        /*文件移除*/
        handleRemove(file, fileList) {
            this.file.map((item, index) => {
                if (item.name == file.name) {
                    this.file.splice(index, 1);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.word {
    p {
        margin-bottom: 24px;
    }
    p.on {
        font-weight: 600;
        color: #333;
        span {
            color: #f00;
        }
    }
}
.mf {
    ::v-deep .el-upload--picture-card {
        display: none !important;
    }
}
.imgDia {
    ::v-deep .el-dialog__header {
        display: none !important;
    }
    ::v-deep .el-dialog__body {
        padding: 20px !important;
        width: 240px;
        // height: 372px;
        img {
            width: 100%;
        }
        & > div {
            width: 200px;
            height: 200px;
        }
    }
}
::v-deep .el-loading-spinner i,
::v-deep .el-loading-spinner .el-loading-text {
    color: #fff;
}
::v-deep .el-radio--medium.is-bordered {
    width: 126px;
}

.calImg {
    ::v-deep .el-dialog__header {
        border-bottom: none !important;
    }
}
</style>